import { FeeRateDto } from '@/services/apis/tx/models'
import { RuleItem, validate } from '@/utils/validator'
import { useState } from 'react'

export type FieldKeys = keyof FeeRateDto
export type FieldRuleMap = Partial<{
  [key in FieldKeys]: {
    force: RuleItem[]
    weak?: RuleItem[]
  }
}>

export type ErrorMap = Partial<{ [field in FieldKeys]: { forceError: boolean; message: string } }>

type DoValidateFn = (newValue: FeeRateDto, fieldRuleMap: FieldRuleMap) => boolean

export function useFeeValidate(): [ErrorMap, DoValidateFn] {
  const [errorMap, setErrorMap] = useState<ErrorMap>({})

  // validate all fields
  const doValidate: DoValidateFn = (newValue, fieldRuleMap: FieldRuleMap) => {
    let tmpErrorMap: ErrorMap = {}

    for (let key in fieldRuleMap) {
      const fieldRule = fieldRuleMap[key as FieldKeys]
      const validValue = newValue[key as FieldKeys]

      const { isValid: forceValid, errMsg: forceValidMessage } = validate(
        validValue!,
        fieldRule!.force
      )

      if (!forceValid) {
        tmpErrorMap[key as FieldKeys] = { forceError: true, message: forceValidMessage }
      } else {
        tmpErrorMap[key as FieldKeys] = { forceError: false, message: '' }
        if ('weak' in fieldRule! && fieldRule!.weak) {
          const { isValid: weakValid, errMsg: weakMessage } = validate(validValue!, fieldRule.weak)
          if (!weakValid) {
            tmpErrorMap[key as FieldKeys] = { forceError: false, message: weakMessage }
          }
        }
      }
    }
    setErrorMap(tmpErrorMap)

    return Object.values(tmpErrorMap).some(e => e.forceError)
  }

  return [errorMap, doValidate]
}

export interface CustomizeFeeRateProps {
  unit?: string
  coinKey: string
  value: FeeRateDto
  mini?: FeeRateDto
  max?: FeeRateDto
  isSpeed?: boolean
  onChangeValue: (error: boolean, feeRateDto: FeeRateDto) => void
}
